module.exports = __webpack_public_path__ + "site/img/149.c53d195c.jpg";